export const getWorkOrderDataProps = state => {
    return state.props
}

export const getWorkOrderAutocompleteList = state => {
    return state.autocomplete_list
}


// WEBPACK FOOTER //
// ./src/store/modules/workOrder/getters.js